import { Observable } from 'rxjs';
import {
  ACCEPT_TEAM_INVITATION_PATH,
  AcceptTeamInvitationPathParams,
  ADD_TEAM_MEMBER_PATH,
  AddTeamMemberBody,
  AddTeamMemberPathParams,
  ApiService,
  ASSIGN_GAMES_TO_TEAM_PATH,
  AssignGamesToTeamBody,
  AssignGamesToTeamPathParams,
  AssignGamesToTeamResponse,
  CREATE_TEAM_PATH,
  CreateResponse,
  CreateTeamBody,
  DELETE_TEAM_PATH,
  DeleteTeamPathParams,
  GET_MY_TEAMS_PATH,
  GET_TEAM_MEMBER_CANDIDATES_PATH,
  GET_TEAM_PATH,
  GetMyTeamsResponse,
  GetTeamMemberCandidatesPathParams,
  GetTeamMemberCandidatesResponse,
  GetTeamPathParams,
  GetTeamResponse,
  LEAVE_TEAM_PATH,
  LeaveTeamPathParams,
  REMOVE_TEAM_MEMBER_PATH,
  RemoveTeamMemberPathParams,
  UPDATE_TEAM_MEMBER_PATH,
  UPDATE_TEAM_PATH,
  UpdateTeamBody,
  UpdateTeamMemberBody,
  UpdateTeamMemberPathParams,
  UpdateTeamPathParams,
  UpdateTeamResponse
} from '@core-http';

export class TeamsService extends ApiService {
  createTeam(payload: CreateTeamBody): Observable<CreateResponse> {
    return this.httpClient.post<CreateResponse>(`${this.env.apiUrl}${CREATE_TEAM_PATH}`, payload);
  }

  assignGamesToTeam(
    pathParams: AssignGamesToTeamPathParams,
    payload: AssignGamesToTeamBody
  ): Observable<AssignGamesToTeamResponse> {
    const path: string = this.fillPathParams(ASSIGN_GAMES_TO_TEAM_PATH, pathParams);

    return this.httpClient.post<AssignGamesToTeamResponse>(`${this.env.apiUrl}${path}`, payload);
  }

  updateTeam(pathParams: UpdateTeamPathParams, payload: UpdateTeamBody): Observable<UpdateTeamResponse> {
    const path: string = this.fillPathParams(UPDATE_TEAM_PATH, pathParams);

    return this.httpClient.patch<UpdateTeamResponse>(`${this.env.apiUrl}${path}`, payload);
  }

  getTeams(): Observable<GetMyTeamsResponse> {
    return this.httpClient.get<GetMyTeamsResponse>(`${this.env.apiUrl}${GET_MY_TEAMS_PATH}`);
  }

  getTeamDetails(pathParams: GetTeamPathParams): Observable<GetTeamResponse> {
    const path: string = this.fillPathParams(GET_TEAM_PATH, pathParams);

    return this.httpClient.get<GetTeamResponse>(`${this.env.apiUrl}${path}`);
  }

  removeMember(pathParams: RemoveTeamMemberPathParams): Observable<void> {
    const path: string = this.fillPathParams(REMOVE_TEAM_MEMBER_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }

  leaveTeam(pathParams: LeaveTeamPathParams): Observable<void> {
    const path: string = this.fillPathParams(LEAVE_TEAM_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }

  removeTeam(pathParams: DeleteTeamPathParams): Observable<void> {
    const path: string = this.fillPathParams(DELETE_TEAM_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }

  updateMember(pathParams: UpdateTeamMemberPathParams, payload: UpdateTeamMemberBody): Observable<void> {
    const path: string = this.fillPathParams(UPDATE_TEAM_MEMBER_PATH, pathParams);

    return this.httpClient.patch<void>(`${this.env.apiUrl}${path}`, payload);
  }

  getCandidates(pathParams: GetTeamMemberCandidatesPathParams): Observable<GetTeamMemberCandidatesResponse> {
    const path: string = this.fillPathParams(GET_TEAM_MEMBER_CANDIDATES_PATH, pathParams);

    return this.httpClient.get<GetTeamMemberCandidatesResponse>(`${this.env.apiUrl}${path}`);
  }

  addTeamMember(pathParams: AddTeamMemberPathParams, payload: AddTeamMemberBody): Observable<void> {
    const path: string = this.fillPathParams(ADD_TEAM_MEMBER_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, payload);
  }

  joinToTeam(pathParams: AcceptTeamInvitationPathParams, token: string): Observable<void> {
    const path: string = this.fillPathParams(ACCEPT_TEAM_INVITATION_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, null, {
      params: { invitationToken: token }
    });
  }
}
